/**
 * Exit from an app in three ways.
 *
 * @module app.exit
 * @author Yaroslav Surilov <y.surilov@infomir.com>
 */

'use strict';

var app          = require('mag-app'),
    keys         = require('stb-keys'),
    LayoutList   = require('mag-component-layout-list'),
    Modal        = require('mag-component-modal'),
    exitModal    = new Modal({
        title: gettext('Exit'),
        events: {
            show: function () {
                this.lastFocus = app.activePage.activeComponent;
                this.children[0].focus();
            },
            hide: function () {
                this.lastFocus.focus();
            }
        },
        children: [
            new LayoutList({
                className: 'padded',
                size: 2,
                focusIndex: 0,
                cycle: true,
                data: [
                    {
                        items: [
                            {
                                value: gettext('Exit')
                            }
                        ],
                        click: function () {
                            core.call('exit');
                        }
                    },
                    {
                        items: [
                            {
                                value: gettext('Cancel')
                            }
                        ],
                        click: function () {
                            exitModal.hide();
                        }
                    }
                ],
                events: {
                    keydown: function ( event ) {
                        LayoutList.prototype.defaultEvents.keydown.call(this, event);
                        if ( event.code === keys.back ) {
                            event.stop = true;
                            exitModal.hide();
                        }
                    }
                }
            })
        ]
    });

module.exports = function ( pageToAddModal ) {
    pageToAddModal.add(exitModal);

    return function () {
        exitModal.show();
    };
};
